const accordions = document.querySelectorAll('.accordion');
const topicButtons = document.querySelectorAll('.accordion__topic-btn');
const topicContents = document.querySelectorAll('.accordion__topic-content');
const mobileDots = document.querySelectorAll('.accordion__dot');
const activeTopicName = document.querySelector('.accordion__active-topic-name');
const indicator = document.querySelector('.accordion__indicator');

accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('.accordion__item');

    items.forEach((el) => {

        el?.addEventListener('click', (e) => {
            toggleAccordionItem(el, accordion);
        });
    });
});

function toggleAccordionItem(item, accordion) {

    // Close all other items
    const items = accordion.querySelectorAll('.accordion__item');
    items.forEach((el) => {
        if (el !== item) {
            el.dataset.state = 'closed';
        }
    });

    // Toggle the clicked item
    const state = item.dataset.state;
    if (state == 'opened') {
      item.dataset.state = 'closed';
    } else if (state == 'closed') {
      item.dataset.state = 'opened';
    }
}

function syncMobileNavWithActiveTopic() {
	const activeButton = document.querySelector('.accordion__topic-btn.is-active');
	const topic = activeButton?.dataset.topic;

	if (topic && activeTopicName) {
		activeTopicName.textContent = activeButton.textContent;

        mobileDots.forEach(dot => {
            dot.classList.toggle('is-active', dot.dataset.topic === topic);
        });
	}
}

function moveIndicator(target) {
  const rect = target.getBoundingClientRect();
  const parentRect = target.parentElement.getBoundingClientRect();

  indicator.style.width = `${rect.width}px`;
  indicator.style.transform = `translateX(${rect.left - parentRect.left - 3}px)`;
}

topicButtons.forEach(button => {
    button.addEventListener('click', () => {
        const topic = button.dataset.topic;

        // Remove 'is-active' from all buttons and contents
        topicButtons.forEach(btn => btn.classList.remove('is-active'));
        topicContents.forEach(content => content.classList.remove('is-active'));

        // Update the active topic name
        button.classList.add('is-active');
        document.querySelector(`.accordion__topic-content[data-topic-content="${topic}"]`).classList.add('is-active');

        moveIndicator(button);
        syncMobileNavWithActiveTopic();
    });
});


mobileDots.forEach(dot => {
    dot.addEventListener('click', () => {
        const topic = dot.dataset.topic;

        // Update dots
        mobileDots.forEach(d => d.classList.remove('is-active'));
        dot.classList.add('is-active');

        // Update topic name
        const topicButton = document.querySelector(`.accordion__topic-btn[data-topic="${topic}"]`);
        if (topicButton && activeTopicName) {
            activeTopicName.textContent = topicButton.textContent;
        }

        // Update accordion content
        topicButtons.forEach(btn => btn.classList.remove('is-active'));
        topicContents.forEach(content => content.classList.remove('is-active'));

        topicButton.classList.add('is-active');
        document.querySelector(`.accordion__topic-content[data-topic-content="${topic}"]`).classList.add('is-active');
    });
});

window.addEventListener('DOMContentLoaded', () => {
    const activeBtn = document.querySelector('.accordion__topic-btn.is-active');
    if (activeBtn) {
        requestAnimationFrame(() => moveIndicator(activeBtn));
    }
});

window.addEventListener('resize', () => {
	syncMobileNavWithActiveTopic();
    const active = document.querySelector('.accordion__topic-btn.is-active');
    if (active) moveIndicator(active);
});

// Slider functionalities
// Swipe
let faqCurrentIndex = 0;
let touchStartX = 0;
let touchEndX = 0;

function getCurrentTopicIndex() {
    return [...topicButtons].findIndex(btn => btn.classList.contains('is-active'));
}

function activateTopicByIndex(index) {
    const clampedIndex = Math.max(0, Math.min(index, topicButtons.length - 1));
    const targetBtn = topicButtons[clampedIndex];

    if (!targetBtn) return;

    const topic = targetBtn.dataset.topic;

    // Update Buttons
    topicButtons.forEach(btn => btn.classList.remove('is-active'));
    targetBtn.classList.add('is-active');

    // Update Contents
    topicContents.forEach(content => content.classList.remove('is-active'));
    document.querySelector(`.accordion__topic-content[data-topic-content="${topic}"]`)?.classList.add('is-active');

    // Update Topic Name
    if (activeTopicName) {
        activeTopicName.textContent = targetBtn.textContent;
    }

    // Update Mobile Dots
    mobileDots.forEach(dot => {
        dot.classList.toggle('is-active', dot.dataset.topic === topic);
    });

    moveIndicator(targetBtn);
}

function handleTouchStartFaq(e) {
    touchStartX = e.changedTouches[0].screenX;
}

function handleTouchEndFaq(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGestureFaq();
}

function handleSwipeGestureFaq() {
    const swipeDistance = touchEndX - touchStartX;

    let index = getCurrentTopicIndex();

    if (swipeDistance > 50) {
        index = Math.max(index - 1, 0); // swipe right
        activateTopicByIndex(index);
    } else if (swipeDistance < -50) {
        index = Math.min(index + 1, topicButtons.length - 1); // swipe left
        activateTopicByIndex(index);
    }
}


// Only on mobile
const faqMediaQuery = window.matchMedia('(max-width: 767px)');

function setupFaqSlider() {
    topicContents.forEach(content => {
        content.addEventListener('touchstart', handleTouchStartFaq);
        content.addEventListener('touchend', handleTouchEndFaq);
    });
}

function destroyFaqSlider() {
    topicContents.forEach(content => {
        content.removeEventListener('touchstart', handleTouchStartFaq);
        content.removeEventListener('touchend', handleTouchEndFaq);
    });
}

function handleFaqViewportChange(e) {
    if (e.matches) {
        setupFaqSlider();
    } else {
        destroyFaqSlider();
    }
}

faqMediaQuery.addEventListener('change', handleFaqViewportChange);

// Initial check
if (faqMediaQuery.matches) {
    setupFaqSlider();
}
